// extracted by mini-css-extract-plugin
export default {"small":"400px","medium":"800px","large":"1200px"};